import type { IFilesystem } from '@livx.cc/wcli/core';

const DEFAULT_NAMES = ['AGENT.md', 'AGENTS.md', 'CLAUDE.md'];

/**
 * Walk the VFS directory tree from `/` down, collecting instruction files
 * (AGENT.md, AGENTS.md, CLAUDE.md, .claude/<name>) at each level.
 * Merges all found files general-first → specific-last (mirrors Claude Code's
 * hierarchical CLAUDE.md discovery). First matching filename per directory wins
 * (no duplicates from the same level). Edge-portable: works over any IFilesystem.
 */
export async function loadInstructions(
  fs: IFilesystem,
  names: string[] = DEFAULT_NAMES,
): Promise<string> {
  // First matching name wins (AGENT.md > AGENTS.md > CLAUDE.md).
  // Both root and .claude/ locations are checked for the winning name — anchored at the FS
  // working dir (in CC-parity disk mode root '/' is the real machine, so instructions live
  // under the launch dir, not '/'). With cwd '/' this is the original behavior.
  const cwd = fs.getCwd();
  const base = cwd === '/' ? '' : cwd;
  for (const name of names) {
    const sections: string[] = [];
    for (const path of [`${base}/${name}`, `${base}/.claude/${name}`]) {
      if (!(await fs.exists(path))) continue;
      const md = (await fs.readFile(path)).trim();
      if (md) sections.push(`<!-- ${path} -->\n${md}`);
    }
    if (sections.length) {
      return `## Project instructions\nRepository-specific instructions — follow them.\n\n${sections.join('\n\n---\n\n')}`;
    }
  }
  return '';
}
